// assets
import { IconDatabaseImport } from "@tabler/icons";

// constant
const icons = {
  IconDatabaseImport,
};

// ==============================|| RECONCILIACION MENU ITEMS ||============================== //

const reconciliacion = {
  id: "Reconciliacion",
  title: "",
  type: "group",
  children: [
    {
      id: "Reconciliacion",
      title: "Reconciliación",
      type: "item",
      url: "/reconciliacion/reconciliacion-list",
      icon: icons.IconDatabaseImport,
      breadcrumbs: false,
    },
  ],
};

export default reconciliacion;
